// @ts-strict-ignore
import safe from 'safe-regex';

export const THRESHOLD_LIMIT = 8000;

function validateRegex(stringRegex: string): RegExp {
  if (stringRegex.startsWith('/')) {
    const regex = stringRegex.substring(1, stringRegex.lastIndexOf('/'));
    const modifiers = stringRegex.substring(stringRegex.lastIndexOf('/') + 1);
    return RegExp(regex, modifiers);
  }

  return RegExp(stringRegex);
}

/**
 * isValidRegex will check if regex is over the character limit
 * then validate, convert string to RegExp, and check if regex is safe
 * before returning true. At any point, if it fails, return false.
 * @param {String} regex
 * @returns {Boolean}
 */
export function isValidRegex(regex: string): boolean {
  if (regex.length > THRESHOLD_LIMIT) return false;

  try {
    const isSafe = safe(regex);
    if (!isSafe) return false;
  } catch {
    return false;
  }

  try {
    validateRegex(regex);
  } catch {
    return false;
  }

  return true;
}
